// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2k1-L","overflowing":"ReadFullNote_overflowing__3zKkz"};